// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signature-options li{padding:3px 10px;margin-bottom:-1px}.signature-options li.active{border:1px solid #ccc;border-bottom:1px solid #fff;border-radius:3px 3px 0 0}.pad.hide{border:0;height:10px}", ""]);
// Exports
module.exports = exports;
